module.exports = __webpack_public_path__ + "media/images/procedure_managements/make_payment_task_preview-70bdea693c9953587a5cf4b2811604be.png";